import { Button, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useDispatch } from "react-redux";
import {
  addItemToCart,
  decrementCartItemCount,
  ICartItem,
} from "../../stateManagement/reducers/cartReducer";
import AnimateButton from "../@extended/AnimateButton";
import borders from "../../assets/theme/base/borders";

interface IProps {
  cartItem: ICartItem;
}

const SelectionButton: FC<IProps> = ({ cartItem }) => {
  const dispatch = useDispatch<any>();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{
        height: "100%",
      }}
    >
      <AnimateButton>
        <Button
          variant="contained"
          size="small"
          color="info"
          sx={{
            minWidth: "2rem !important",
            color: "white !important",
            fontWeight: "700",
            background: "linear-gradient(to top, #8b0000, #ff5e57)",
            borderRadius: borders.borderRadius.md,
            px: "0 !important",
          }}
          onClick={() => {
            dispatch(
              decrementCartItemCount({
                rentalItemId: cartItem.rentalItem._id,
                count: 1,
              }),
            );
          }}
        >
          -
        </Button>
      </AnimateButton>
      <Typography
        sx={{ px: ".5rem", color: "black !important", fontFamily: "Inter" }}
      >
        <b>{cartItem.count}</b>
      </Typography>
      <AnimateButton>
        <Button
          variant="contained"
          size="small"
          color="info"
          sx={{
            minWidth: "2rem !important",
            color: "white !important",
            fontWeight: "700",
            background: "linear-gradient(to top,#2b6e3f, #4caf50)",
            borderRadius: borders.borderRadius.md,
            px: "0 !important",
          }}
          onClick={() => {
            dispatch(
              addItemToCart({ rentalItem: cartItem.rentalItem, count: 1 }),
            );
          }}
        >
          +
        </Button>
      </AnimateButton>
    </Stack>
  );
};

export default SelectionButton;
